module.exports = __webpack_public_path__ + "img/v3.5531a5f2.png";